// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HttpIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HttpIcon" ref={forwardedRef} {...props}>
      <path d="M2.37 10.64h2.26v2.86H6v-7H4.63v2.78H2.37V6.5H1v7h1.37z" />
      <path d="M6.75 6.5h3.5v1.361H9.207V13.5H7.903V7.861H6.751z" />
      <path d="M14.25 6.5h-3.5v1.361h1.153V13.5h1.304V7.861h1.043z" />
      <path d="M17.31 6.5H15v7h1.32v-2.356h.99c1.343 0 2.19-.95 2.19-2.334S18.653 6.5 17.31 6.5m.88 2.333c0 .595-.34.973-.913.973H16.32V7.86h.957c.573 0 .914.378.914.972" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HttpIcon = /* @__PURE__ */ Object.assign(HttpIconComponent, {
  displayName: 'HttpIcon',
});
